fmtvMigratedNoGaiaBillingAccount